import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import tw from "tailwind-styled-components";
export const _SBadge = tw.span`
text-xs
text-opacity-90
border
border-opacity-20
${({ $variant })=>{
    if (!$variant || $variant === "primary") {
        return `text-brand-primary border-brand-primary`;
    } else {
        return `text-white border-white border-opacity-40 opacity-60`;
    }
}}
font-semibold
rounded-md
bg-opacity-10
py-1
px-2
inline-flex
items-center
justify-center

${({ $whitespace })=>{
    return $whitespace === "nowrap" ? "whitespace-nowrap" : `whitespace-normal`;
}}
`;
export const SBeta = ()=>{
    return /*#__PURE__*/ _jsx(_SBadge, {
        children: `BETA`
    });
};
export const NewBadge = ({ endDate })=>{
    // Parse end data
    const endDateParsed = typeof endDate === "string" ? new Date(endDate) : endDate;
    const currentDate = new Date();
    if (currentDate < endDateParsed) {
        return /*#__PURE__*/ _jsx(_SBadge, {
            children: "New"
        });
    } else {
        return null;
    }
};
const SBadge = _SBadge;
SBadge.Beta = SBeta;
SBadge.New = NewBadge;
export default SBadge;
